import { useEffect, useMemo, useState } from 'react';
import {
  subscribeLicitacionesSinLiquidar,
  subscribeOrdenesDeLicitaciones,
} from '../services/licitacionesService';
import { buildDebitosLicitaciones, licitacionImpactaSaldo } from '../utils/licitacionesCalculator';

/**
 * Débitos de las licitaciones adjudicadas que impactan el saldo de `fecha`
 * (ver buildDebitosLicitaciones). `comitentes` = null en modo staff; en modo
 * productor, su padrón.
 *
 * Solo se suscribe a las órdenes de las licitaciones que están hoy en ventana de
 * caja, así que en un día sin licitaciones no lee ninguna orden.
 */
export const useDebitosLicitaciones = ({ user, fecha, comitentes = null }) => {
  const [licitaciones, setLicitaciones] = useState([]);
  const [ordenes, setOrdenes] = useState([]);

  const comitentesKey = Array.isArray(comitentes) ? comitentes.join('|') : null;

  useEffect(() => {
    if (!user || !fecha) {
      setLicitaciones([]);
      return undefined;
    }
    return subscribeLicitacionesSinLiquidar(fecha, setLicitaciones, () => setLicitaciones([]));
  }, [user, fecha]);

  const idsEnCajaKey = useMemo(
    () => licitaciones
      .filter(licitacion => licitacionImpactaSaldo(licitacion, fecha))
      .map(licitacion => licitacion.id)
      .sort()
      .join('|'),
    [licitaciones, fecha],
  );

  useEffect(() => {
    if (!user || !idsEnCajaKey) {
      setOrdenes([]);
      return undefined;
    }
    const filtro = comitentesKey === null ? null : (comitentesKey ? comitentesKey.split('|') : []);
    return subscribeOrdenesDeLicitaciones(
      idsEnCajaKey.split('|'),
      filtro,
      setOrdenes,
      () => setOrdenes([]),
    );
  }, [user, idsEnCajaKey, comitentesKey]);

  return useMemo(
    () => buildDebitosLicitaciones(licitaciones, ordenes, fecha),
    [licitaciones, ordenes, fecha],
  );
};
